export const BRAND_LOADING = 'BRAND_LOADING';
export const BRAND_SUCCESS = 'BRAND_SUCCESS';
export const BRAND_FAILED = 'BRAND_FAILED';
export const RESET_ERROR="RESET_ERROR"